// Hero CTA copy test on the mobile-proof money pages (growth list #12, October 20, 2026).
// Server render and crawlers always get arm "a". In the browser, an English page with
// analytics consent gets a sticky 50/50 arm; the arm rides on start_free_click as
// cta_variant, and one cta_test_exposure per page view gives the denominator.
// Both arms link to the same Voyager trial with the same disclosure; only the words differ.
export const CTA_TEST_ID = 'mobile_proof_hero_2026_10';
export const CTA_TEST_STORAGE_KEY = `w369_cta_${CTA_TEST_ID}`;

export type CtaVariant = 'a' | 'b';

export const CTA_TEST_COPY: Record<CtaVariant, string> = {
  a: 'Try Voyager free for 14 days',
  b: 'Send your first proposal free',
};

export const isCtaVariant = (value: unknown): value is CtaVariant => value === 'a' || value === 'b';

// A stored arm wins; otherwise roll one. `random` is Math.random in the browser.
export function assignCtaVariant(stored: string | null | undefined, random: () => number): { variant: CtaVariant; fresh: boolean } {
  if (isCtaVariant(stored)) return { variant: stored, fresh: false };
  return { variant: random() < 0.5 ? 'a' : 'b', fresh: true };
}

export const ctaTestEligible = (analyticsConsent: boolean, localeCode: string, enrolledPage: boolean) =>
  analyticsConsent && localeCode === 'en' && enrolledPage;

export function ctaExposureEvent(variant: CtaVariant, pagePath: string) {
  return { event: 'cta_test_exposure', event_category: 'experiment', cta_test: CTA_TEST_ID, cta_variant: variant, page_path: pagePath };
}
